import React, { Fragment } from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.jpg'
import heartImg from './img/heart.svg'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro293">
      <div className="intro293mobile screen">
        <img
          className="main-background-aoV2aY"
          src={background || backgroundImg}
        />
        <div className="mask-overlay-aoV2aY" />
        <div className="container-center-horizontal">
          <div className="button-aoV2aY">
            <p
              className="site-de-casamento-e-Mz3DQC"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-Mz3DQC" onClick={onSkipIntro}>
              <div className="button-TryIll"></div>
              <div className="pular-introduo-TryIll">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="content">
          <div className="vo-se-casar-aoV2aY">{text}</div>
          <div className="couple-name-aoV2aY">
            <div className="couple-single-namebr-7KPgMA bp2-animate-enter">
              {coupleSingleName.bride}{' '}
              {coupleSingleName.groom && (
                <Fragment>
                  e <br /> {coupleSingleName.groom}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="intro293desktop screen">
        <img
          className="main-background-h3VxPD"
          src={background || backgroundImg}
        />
        <div className="mask-overlay-h3VxPD" />
        <div className="container-center-horizontal">
          <div className="button-h3VxPD">
            <p
              className="site-de-casamento-e-wyL3E7"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button className="button-wyL3E7" onClick={onSkipIntro}>
              <div className="button-awcy2J"></div>
              <div className="pular-introduo-awcy2J">{buttonMessage}</div>
            </button>
          </div>
        </div>
        <div className="content">
          <div className="vo-se-casar-h3VxPD">{text}</div>
          <div className="couple-name-h3VxPD">
            <img
              className="heart-right-1vtVYp bp1-animate-enter"
              src={heartImg}
            />
            <h1 className="couple-single-namebr-1vtVYp bp1-animate-enter1">
              {coupleSingleName.bride}
              {coupleSingleName.groom && ` e ${coupleSingleName.groom}`}
            </h1>
            <img
              className="heart-left-1vtVYp bp1-animate-enter2"
              src={heartImg}
            />
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
